/**
 * 48 kỹ năng đo được từ 107/108 mô tả công việc.
 *
 * `jobs` = số tin thực sự nhắc tới kỹ năng đó, lấy bằng cách quét TOÀN VĂN
 * JD gốc (không phải đọc nhãn trên aitmpl — đã kiểm 20 nhãn thì 14 nhãn
 * không hề xuất hiện trong JD, "Rust" và "AWS" bị dán bừa vào gần như mọi
 * tin Anthropic kể cả vị trí Product Manager).
 *
 * `have` = đã chứng minh được qua kho api-backend (cuongthai.com). Cơ sở:
 * chính CLAUDE.md của kho — Next.js + Express + TypeScript + Prisma +
 * PostgreSQL, Docker, GitHub Actions, VPS, Cloudflare R2, và Claude Code
 * dùng hằng ngày. Nếu đánh giá này sai, sửa cờ ở đây là cả trang tự cập nhật.
 */
import type { Skill } from './types';

export const SKILLS: Skill[] = [
  // ─────────────── Làm việc với AI agent ───────────────
  {
    id: 'claude-code',
    name: 'Claude Code',
    jobs: 75,
    group: 'agentic',
    have: true,
    why: 'Kỹ năng được nhắc nhiều nhất — 7/10 tin. Nhưng gần như tin nào cũng kèm một câu cảnh báo: "bạn là kỹ sư, không phải thợ gõ prompt". Họ không trả tiền cho việc bạn biết mở terminal.',
    learn: [
      'Đừng ghi "biết dùng Claude Code" trong hồ sơ — ai cũng ghi thế. Ghi thứ bạn ĐÃ SHIP bằng nó, kèm số: bao nhiêu module, bao nhiêu dòng, chạy thật cho ai.',
      'Học cách viết CLAUDE.md tốt: nội quy dự án, việc cấm làm, checklist trước khi đẩy. Chính tệp CLAUDE.md của kho api-backend là ví dụ mẫu — đưa nó ra khi phỏng vấn.',
      'Biết chỗ agent hay sai và cách chặn trước: đó mới là phần "human judgment" mà mọi JD đòi.',
    ],
  },
  {
    id: 'agentic',
    name: 'AI agents / agentic',
    jobs: 42,
    group: 'agentic',
    have: false,
    why: 'Khác chatbot: agent tự quyết gọi công cụ nào, chạy nhiều bước, tự sửa khi sai. Đây là ranh giới giữa "biết xài AI" và "kỹ sư AI".',
    learn: [
      'Hiểu vòng lặp cốt lõi: model → chọn tool → chạy tool → đưa kết quả về → lặp tới khi xong. Tự viết vòng lặp này một lần bằng tay, đừng dùng framework ngay.',
      'Định nghĩa tool cho đúng: tên rõ, mô tả rõ, schema tham số chặt. Tool mô tả mơ hồ là nguyên nhân số một khiến agent gọi sai.',
      'Xử lý lỗi: tool ném lỗi thì agent phải đọc được lỗi và thử lại, không phải chết cả phiên.',
      'Làm dự án số 1 trong tab Dự án — đó chính là bài này.',
    ],
  },
  {
    id: 'llm',
    name: 'LLM (hiểu bản chất)',
    jobs: 39,
    group: 'agentic',
    have: false,
    why: 'Biết mô hình làm được gì và KHÔNG làm được gì. 39 tin nhắc tới, và nhiều tin nói thẳng "LLM ảo giác nên không được để nó tự sinh ra con số".',
    learn: [
      'Nắm chắc: token, context window, temperature, streaming, giá theo token vào/ra.',
      'Hiểu vì sao không được để LLM tự tính toán — cho nó điều phối, còn số liệu phải chạy qua code tất định. Tin Kepler nói đúng ý này.',
      'Biết prompt caching để giảm giá — thứ ai làm thật cũng phải đụng.',
    ],
  },
  {
    id: 'evals',
    name: 'Evals (đo chất lượng AI)',
    jobs: 19,
    group: 'agentic',
    have: false,
    why: 'Thứ tách người làm nghiêm túc khỏi người làm demo. Không có evals thì không biết sửa prompt xong tốt lên hay tệ đi. Rất ít ứng viên junior có cái này — nên nó là lợi thế rẻ nhất bạn mua được.',
    learn: [
      'Bắt đầu cực đơn giản: 20–30 cặp (đầu vào → đầu ra mong muốn) viết tay, chạy qua model, đếm bao nhiêu đạt.',
      'Ba kiểu chấm: khớp chính xác, khớp theo luật (regex/JSON hợp lệ), và dùng model khác chấm.',
      'Quan trọng nhất: chạy lại được. Đổi prompt → chạy lại → so điểm cũ với điểm mới.',
      'Ghi kết quả ra bảng theo thời gian. Chính cái bảng đó là thứ đem đi phỏng vấn.',
    ],
  },
  {
    id: 'mcp',
    name: 'MCP (Model Context Protocol)',
    jobs: 19,
    group: 'agentic',
    have: false,
    why: 'Chuẩn để agent cắm vào dữ liệu và công cụ bên ngoài. 19 tin nhắc tới, và cả một công ty trong danh sách (MintMCP) sống bằng nghề này.',
    learn: [
      'Hiểu MCP giải bài toán gì: thay vì mỗi app tự viết cách nối riêng, mọi công cụ nói chung một giao thức.',
      'Tự viết một MCP server nhỏ cắm vào dữ liệu CỦA BẠN — dự án số 2 trong tab Dự án.',
      'Biết ranh giới quyền: MCP server chạm được gì, và vì sao không được đưa khoá bí mật vào đó.',
    ],
  },
  {
    id: 'prompt',
    name: 'Prompt engineering',
    jobs: 17,
    group: 'agentic',
    have: false,
    why: 'Không phải "câu thần chú", mà là viết đặc tả rõ ràng cho một cộng sự đọc rất nhanh nhưng không đoán được ý bạn.',
    learn: [
      'Viết prompt như viết ticket: bối cảnh, việc cần làm, định dạng đầu ra, ví dụ, và điều KHÔNG được làm.',
      'Ép đầu ra có cấu trúc (JSON theo schema) thay vì văn xuôi rồi tự parse.',
      'Đo bằng evals chứ đừng đo bằng cảm giác "câu này nghe xịn hơn".',
    ],
  },
  {
    id: 'rag',
    name: 'RAG (truy hồi rồi mới trả lời)',
    jobs: 7,
    group: 'agentic',
    have: false,
    why: 'Cách cho model trả lời đúng trên dữ liệu riêng mà không cần huấn luyện lại. Ít tin nhắc tên, nhưng nhiều tin mô tả đúng bài toán này.',
    learn: [
      'Chuỗi tối thiểu: cắt tài liệu thành đoạn → tạo embedding → tìm đoạn gần nhất → nhét vào prompt.',
      'Cắt đoạn mới là phần khó, không phải chọn vector DB. Cắt sai thì tìm gì cũng trượt.',
      'Luôn trả kèm nguồn để kiểm được — công ty nào cũng hỏi câu này.',
      'Bạn có sẵn kho nội dung khổng lồ ở cuongthai.com để làm thật: dự án số 3.',
    ],
  },
  {
    id: 'vector',
    name: 'Vector DB / embeddings',
    jobs: 4,
    group: 'agentic',
    have: false,
    why: 'Hạ tầng cho RAG. Ít tin đòi đích danh vì phần lớn dùng pgvector cho gọn.',
    learn: [
      'Dùng pgvector ngay trên PostgreSQL bạn đang chạy — không cần thêm dịch vụ mới.',
      'Hiểu embedding là gì bằng một ví dụ: hai câu cùng nghĩa khác chữ thì khoảng cách gần nhau.',
    ],
  },
  {
    id: 'cursor',
    name: 'Cursor',
    jobs: 22,
    group: 'agentic',
    have: false,
    why: 'Công cụ thứ hai hay được nhắc cùng Claude Code. Nhiều tin liệt kê cả cụm "Claude Code, Cursor, Aider".',
    learn: ['Cài và dùng thật vài buổi để nói được điểm khác nhau — câu hỏi phỏng vấn rất hay gặp.'],
  },
  {
    id: 'codex',
    name: 'Codex',
    jobs: 13,
    group: 'agentic',
    have: false,
    why: 'Xuất hiện trong nhóm công cụ agent mà các công ty đang thử song song.',
    learn: ['Biết nó tồn tại và khác gì Claude Code là đủ ở mức junior.'],
  },
  {
    id: 'cowork',
    name: 'Cowork',
    jobs: 10,
    group: 'agentic',
    have: false,
    why: 'Xuất hiện trong 10 tin, gồm cả tin tuyển vị trí phi kỹ thuật (FeedbackPulse tuyển HR dùng Cowork hằng ngày).',
    learn: ['Đọc qua để biết nó là gì — đủ để không ngỡ ngàng khi JD nhắc tên.'],
  },
  {
    id: 'copilot',
    name: 'GitHub Copilot',
    jobs: 5,
    group: 'agentic',
    have: false,
    learn: ['Biết tên là đủ, không cần đầu tư.'],
  },
  {
    id: 'finetune',
    name: 'Fine-tuning',
    jobs: 2,
    group: 'agentic',
    have: false,
    why: 'Chỉ 2 tin. Đừng học sớm — hầu hết bài toán thật giải bằng prompt tốt + RAG rẻ hơn nhiều.',
    learn: ['Bỏ qua ở giai đoạn này. Quay lại khi có bài toán thật cần tới.'],
  },
  {
    id: 'ai-safety',
    name: 'An toàn AI / trust & safety',
    jobs: 16,
    group: 'agentic',
    have: false,
    why: 'Chống lạm dụng, chặn agent làm bậy, xử lý dữ liệu không tin cậy đi vào prompt.',
    learn: [
      'Nắm prompt injection: nội dung lấy từ web/tệp của người dùng là DỮ LIỆU, không phải mệnh lệnh.',
      'Nguyên tắc quyền tối thiểu cho tool: agent chỉ được chạm đúng thứ nó cần.',
    ],
  },

  // ─────────────── Ngôn ngữ ───────────────
  {
    id: 'python',
    name: 'Python',
    jobs: 48,
    group: 'lang',
    have: false,
    why: 'Ngôn ngữ được đòi nhiều nhất, gần gấp rưỡi TypeScript. Thế giới AI chạy bằng Python — mọi SDK, mọi thư viện xử lý dữ liệu đều ở đó trước.',
    learn: [
      'Bạn đã biết lập trình rồi, đây chỉ là đổi cú pháp — đừng học lại từ "biến là gì".',
      'Đủ dùng gồm: kiểu dữ liệu cơ bản, list/dict comprehension, async/await, type hints, virtualenv + pip.',
      'Rồi tới FastAPI (rất giống Express về tư duy) và SDK `anthropic`.',
      'Cách nhanh nhất và có sản phẩm luôn: viết lại MỘT service nhỏ đang có trong api-backend bằng Python — dự án số 4.',
    ],
  },
  {
    id: 'typescript',
    name: 'TypeScript',
    jobs: 31,
    group: 'lang',
    have: true,
    why: 'Ngôn ngữ thứ hai được đòi nhiều nhất. Bạn đã dùng cho cả backend lẫn frontend.',
    learn: [
      'Nâng lên mức nói được: vì sao chọn kiểu này thay kiểu kia, generic để làm gì, khi nào `unknown` tốt hơn `any`.',
    ],
  },
  {
    id: 'rust',
    name: 'Rust',
    jobs: 14,
    group: 'lang',
    have: false,
    why: 'CẢNH BÁO: con số 14 này gây hiểu nhầm. Rất nhiều lần "Rust" bị chính aitmpl dán bừa; khi đọc JD gốc thì phần lớn tin Anthropic KHÔNG hề đòi Rust.',
    learn: ['Đừng học vì con số này. Chỉ học nếu bạn nhắm đúng một tin cụ thể có đòi thật.'],
  },
  {
    id: 'go',
    name: 'Go (Golang)',
    jobs: 11,
    group: 'lang',
    have: false,
    why: 'Hay gặp ở các công ty làm hạ tầng (Railway, ArtCraft, Cora AI).',
    learn: ['Để sau. Chỉ đụng khi đã xong Python và nhắm đúng công ty dùng Go.'],
  },
  {
    id: 'ruby',
    name: 'Ruby / Rails',
    jobs: 4,
    group: 'lang',
    have: false,
    learn: ['Bỏ qua trừ khi nhắm đúng tin dùng Rails (Authorium, Scribd, TrakPro).'],
  },
  {
    id: 'elixir',
    name: 'Elixir / Phoenix',
    jobs: 2,
    group: 'lang',
    have: false,
    learn: ['Bỏ qua.'],
  },
  {
    id: 'java',
    name: 'Java',
    jobs: 2,
    group: 'lang',
    have: false,
    learn: ['Bỏ qua ở lộ trình này — bạn đã học ở trường là đủ.'],
  },

  // ─────────────── Web & framework ───────────────
  {
    id: 'react',
    name: 'React',
    jobs: 24,
    group: 'web',
    have: true,
    why: 'Vẫn là mặc định của frontend. Bạn đã dùng ở toàn bộ cuongthai.com.',
  },
  {
    id: 'nextjs',
    name: 'Next.js',
    jobs: 13,
    group: 'web',
    have: true,
    why: 'Framework được nhắc nhiều nhất trong nhóm web.',
    learn: ['Nói được vì sao chọn App Router, chỗ nào server component chỗ nào client, và cái giá của mỗi lựa chọn.'],
  },
  {
    id: 'nodejs',
    name: 'Node.js',
    jobs: 5,
    group: 'web',
    have: true,
  },
  {
    id: 'api',
    name: 'API / REST / GraphQL',
    jobs: 13,
    group: 'web',
    have: true,
    learn: ['Nâng lên: phiên bản hoá API, phân trang, giới hạn tốc độ, mã lỗi cho tử tế.'],
  },
  {
    id: 'django',
    name: 'Django',
    jobs: 4,
    group: 'web',
    have: false,
    learn: ['Học sau FastAPI, và chỉ khi nhắm tin có đòi.'],
  },
  {
    id: 'rn',
    name: 'React Native',
    jobs: 4,
    group: 'web',
    have: false,
    learn: ['Bỏ qua trừ khi thích làm mobile.'],
  },
  {
    id: 'supabase',
    name: 'Supabase',
    jobs: 4,
    group: 'web',
    have: false,
    learn: ['Bạn tự dựng Postgres rồi nên hiểu ngay — chỉ cần thử một buổi.'],
  },

  // ─────────────── Dữ liệu ───────────────
  {
    id: 'postgres',
    name: 'PostgreSQL',
    jobs: 25,
    group: 'data',
    have: true,
    why: 'Cơ sở dữ liệu được đòi nhiều nhất, bỏ xa phần còn lại.',
    learn: [
      'Nâng lên mức phỏng vấn được: đọc `EXPLAIN ANALYZE`, biết khi nào index có tác dụng, hiểu transaction và deadlock.',
      'Có hẳn một công ty trong danh sách (pganalyze) sống bằng nghề tối ưu Postgres — đọc blog của họ là học được nhiều.',
    ],
  },
  {
    id: 'sql',
    name: 'SQL',
    jobs: 8,
    group: 'data',
    have: true,
    learn: ['Luyện window function và CTE — hai thứ hay hỏi mà người dùng ORM lâu ngày thường quên.'],
  },
  {
    id: 'pipeline',
    name: 'Data pipeline / ETL',
    jobs: 14,
    group: 'data',
    have: false,
    why: 'Chuyển dữ liệu từ nơi này sang nơi khác, sạch và đều đặn. Nhiều tin ở mảng y tế, tài chính, quảng cáo cần đúng cái này.',
    learn: [
      'Hiểu ba chữ: trích xuất, biến đổi, nạp. Và vì sao phải chạy lại được mà không hỏng dữ liệu (idempotent).',
      'Làm thật: dự án số 5 — pipeline gom tin tuyển dụng, chính là thứ aitmpl đang làm (và làm khá ẩu).',
    ],
  },

  // ─────────────── Hạ tầng & vận hành ───────────────
  {
    id: 'sysdesign',
    name: 'Thiết kế hệ thống / quy mô',
    jobs: 63,
    group: 'infra',
    have: true,
    why: 'Yêu cầu lớn thứ hai sau chính Claude Code. Đây là thứ quyết định bạn được xếp junior hay mid.',
    learn: [
      'Bạn ĐÃ làm thật: triển khai không gián đoạn, migration Prisma, hàng đợi, cache, R2. Thiếu là KỂ LẠI được.',
      'Với mỗi quyết định, tập trả lời ba câu: vì sao chọn nó, đánh đổi cái gì, nếu tải gấp 100 lần thì hỏng ở đâu trước.',
      'Bảng "Known Error Patterns" trong CLAUDE.md của bạn là vàng — mỗi dòng là một câu chuyện phỏng vấn có thật, có nguyên nhân và cách sửa.',
    ],
  },
  {
    id: 'obs',
    name: 'Observability / giám sát',
    jobs: 21,
    group: 'infra',
    have: false,
    why: 'Công ty nào chạy thật cũng cần biết hệ thống đang sống hay chết, và chết ở đâu. Bạn đang chạy production mà chưa có phần này.',
    learn: [
      'Ba trụ: log có cấu trúc, số đo (metrics), và truy vết (trace).',
      'Bắt đầu rẻ: gắn Sentry cho backend + frontend, rồi thêm một trang trạng thái đơn giản.',
      'Làm thật trên chính cuongthai.com — dự án số 6. Đây là dự án có lợi kép: vừa học, vừa đỡ mù khi prod hỏng.',
    ],
  },
  {
    id: 'aws',
    name: 'AWS',
    jobs: 19,
    group: 'infra',
    have: false,
    why: 'Nền tảng đám mây phổ biến nhất trong danh sách. Bạn đang tự quản VPS nên hiểu khái niệm rồi, chỉ thiếu tên gọi của AWS.',
    learn: [
      'Đủ dùng cho phỏng vấn junior: S3 (giống R2 bạn đang dùng), EC2, RDS, Lambda, IAM.',
      'Không cần lấy chứng chỉ. Dựng một thứ nhỏ chạy thật là đủ nói chuyện.',
    ],
  },
  {
    id: 'gcp',
    name: 'GCP',
    jobs: 14,
    group: 'infra',
    have: false,
    learn: ['Học sau AWS, và chỉ ở mức đối chiếu tên dịch vụ.'],
  },
  {
    id: 'azure',
    name: 'Azure',
    jobs: 5,
    group: 'infra',
    have: false,
    learn: ['Bỏ qua.'],
  },
  {
    id: 'docker',
    name: 'Docker',
    jobs: 5,
    group: 'infra',
    have: true,
    why: 'Ít tin nhắc đích danh vì nó đã thành mặc định — ai cũng ngầm hiểu bạn phải biết.',
    learn: ['Nói được: build nhiều tầng để làm gì, vì sao thứ tự lệnh trong Dockerfile ảnh hưởng thời gian build.'],
  },
  {
    id: 'k8s',
    name: 'Kubernetes',
    jobs: 6,
    group: 'infra',
    have: false,
    why: 'Chỉ 6 tin. Đừng để nó chiếm mất thời gian của Python.',
    learn: ['Để sau cùng. Biết khái niệm pod/service/deployment là đủ trả lời.'],
  },
  {
    id: 'cicd',
    name: 'CI/CD',
    jobs: 9,
    group: 'infra',
    have: true,
    why: 'Bạn đã có GitHub Actions chạy thật, kèm cả smoke-test sau khi triển khai — nhiều dev đi làm vài năm vẫn chưa tự dựng.',
    learn: ['Kể được vụ smoke-test bắt lỗi 404 do build cũ — đó là câu chuyện rất "kỹ sư".'],
  },
  {
    id: 'terraform',
    name: 'Terraform / IaC',
    jobs: 3,
    group: 'infra',
    have: false,
    learn: ['Để sau cùng.'],
  },
  {
    id: 'linux',
    name: 'Linux / shell',
    jobs: 3,
    group: 'infra',
    have: true,
    why: 'Bạn tự viết deploy.sh và vận hành VPS — phần này đã vững.',
  },
  {
    id: 'testing',
    name: 'Testing / QA',
    jobs: 13,
    group: 'infra',
    have: false,
    why: 'Chỗ hổng rõ nhất trong kho api-backend hiện tại. Càng dùng AI sinh code, test càng quan trọng — vì đó là thứ duy nhất chặn được code trông đúng mà chạy sai.',
    learn: [
      'Bắt đầu từ phần dễ vỡ nhất, đừng cố phủ hết: xác thực, thanh toán, quyền truy cập.',
      'Vitest cho backend, Playwright cho luồng người dùng.',
      'Nối vào GitHub Actions để test chạy trước mỗi lần triển khai — dự án số 7.',
    ],
  },
  {
    id: 'git',
    name: 'Git / code review',
    jobs: 5,
    group: 'infra',
    have: true,
    learn: ['Tập viết mô tả PR bằng tiếng Anh: bối cảnh, thay đổi gì, kiểm thế nào. Vừa luyện tiếng Anh vừa thành hồ sơ công khai.'],
  },
  {
    id: 'security',
    name: 'Bảo mật / tuân thủ',
    jobs: 23,
    group: 'infra',
    have: true,
    why: 'Đòi nhiều bất ngờ — 23 tin, nhất là mảng y tế (HIPAA) và doanh nghiệp (SOC 2).',
    learn: [
      'Bạn đã có đợt rà soát bảo mật thật trong dự án (HSTS, giới hạn tốc độ, vá CVE) — đó là chất liệu tốt.',
      'Bổ sung phần AI: prompt injection, rò rỉ khoá, và vì sao khoá bên thứ ba không bao giờ được để ở biến `NEXT_PUBLIC_*`.',
    ],
  },

  // ─────────────── Không phải code ───────────────
  {
    id: 'english',
    name: 'Giao tiếp & viết (tiếng Anh)',
    jobs: 46,
    group: 'soft',
    have: false,
    why: 'Rào cản số một, và không phải rào cản kỹ thuật. Mọi việc nhóm A đều là hợp đồng từ xa với team nước ngoài — không viết được cập nhật tiến độ mạch lạc thì không ai nhận, dù code giỏi.',
    learn: [
      'Viết trước, nói sau. Viết rẻ hơn và có thể sửa được.',
      'Mỗi ngày: một mô tả PR bằng tiếng Anh trong chính kho này. Ngắn cũng được, đều là được.',
      'Mỗi tuần: một đoạn 150 từ kể một thứ bạn vừa sửa — đó chính là khung trả lời phỏng vấn.',
      'Bạn đã có sẵn lộ trình IELTS và khoá giao tiếp 30 ngày trên site này. Chúng không phải việc phụ — chúng là việc chính.',
    ],
  },
  {
    id: 'ownership',
    name: 'Tự chủ sản phẩm (ownership)',
    jobs: 48,
    group: 'soft',
    have: true,
    why: 'Đòi ngang Python. Nghĩa là: tự nhận việc mơ hồ, tự chia nhỏ, tự làm tới lúc chạy được, không chờ ai giao từng bước.',
    learn: [
      'Bạn đã chứng minh rồi — tự dựng cả một nền tảng nhiều module, tự triển khai, tự sửa khi prod hỏng.',
      'Thiếu là cách KỂ: nêu vấn đề → cách bạn chọn → kết quả đo được. Ba câu, không dài hơn.',
    ],
  },
  {
    id: 'startup',
    name: 'Làm ở môi trường startup',
    jobs: 38,
    group: 'soft',
    have: false,
    why: 'Phần lớn tin trong danh sách là startup nhỏ: ít người, nhiều việc, đổi hướng nhanh, không ai cầm tay chỉ việc.',
    learn: [
      'Họ đang tìm dấu hiệu: bạn có tự làm ra thứ gì đó trọn vẹn một mình chưa. Bạn có — hãy nói thẳng điều đó.',
      'Chuẩn bị câu trả lời cho: "làm sao bạn quyết định làm gì trước khi mọi thứ đều gấp".',
    ],
  },
  {
    id: 'customer',
    name: 'Làm việc với khách hàng',
    jobs: 28,
    group: 'soft',
    have: false,
    why: 'Nhiều vị trí là kỹ sư nhưng phải ngồi họp với khách (forward deployed, solutions architect, pre-sales).',
    learn: [
      'Tập giải thích một thứ kỹ thuật cho người không biết code, trong 3 câu.',
      'Đây là nhóm việc trả lương cao mà ít dev Việt Nam nhắm tới — vì ngại tiếng Anh, không phải vì thiếu kỹ thuật.',
    ],
  },
];

/** Tra nhanh theo id — dùng ở tab Lộ trình và Dự án để hiện tên kỹ năng. */
export const SKILL_BY_ID: Record<string, Skill> = Object.fromEntries(
  SKILLS.map((s) => [s.id, s]),
);

/** Nhãn tiếng Việt cho từng nhóm kỹ năng. */
export const GROUP_LABEL: Record<Skill['group'], string> = {
  agentic: 'Làm việc với AI agent',
  lang: 'Ngôn ngữ lập trình',
  web: 'Web & framework',
  data: 'Dữ liệu',
  infra: 'Hạ tầng & vận hành',
  soft: 'Không phải code',
};
